<z-drawer [open]="true" (openChange)="closeDrawer($event)" [dir]="(language | language)?'rtl':'ltr'">
    <ng-container header>
        <div class="flex flex-row  items-center  gap-2">
            <h4 class="text-2xl leading-10 font-bold text-zen">
                {{ "txt_Filters_432" | translate:language:ModuleNames.Common }}</h4>
        </div>
        <div class="flex flex-row gap-5 items-center">
            <a class="btn block ghost h-10 leading-10 rounded text-center text-sm w-max px-5" (click)="resetAll()">
                {{ "Reset" | translate:language:ModuleNames.Common }}</a>
            <a class="btn block exp h-10 leading-10 rounded text-center text-sm w-max px-5" (click)="apply(form)">
                {{ "Apply" | translate:language:ModuleNames.Common }}</a>
        </div>
    </ng-container>
    <ng-container body class="">
        <form #form="ngForm" (click)="logData(filters)"
            class="flex flex-col gap-10 py-10 relative px-10 bg-zen-blueWhite max-w-38 min-w-38 min-h-screen-drawer overflow-x-hidden">
            <ng-container *ngTemplateOutlet="data.template"></ng-container>
            <div *ngFor="let section of filters;" class="flex flex-col gap-5">
                <ng-container *ngIf="section?.criteria?.length  || section.key == 'BusinessLevel'">
                    <div *ngIf="section.key == 'BusinessLevel'">

                        <ng-container *ngIf="globalFilterHelper.treeList$ | async as treeList">
                            <div (click)="setActivatedCriteria('tree')" class="flex flex-row items-center gap-1 btn">
                                <a class="w-4"><i
                                        [ngClass]="activatedCriteria == 'tree'?'fa-solid text-exp fa-circle-dot':'fa-regular fa-circle'"></i></a>
                                <h3 class="text-sm text-zen font-medium text-opacity-50">
                                    {{ section.name | translate:language:ModuleNames.Shared }}</h3>
                            </div>
                            <div [ngClass]="activatedCriteria == 'tree'?'opacity-100 pointer-events-auto':'opacity-60 pointer-events-none'"
                                class="flex flex-col items-stretch">
                                <zen-tree customClass=" bg-transparent " [data]="treeList?.children"
                                    [autoSelect]="false">
                                    <ng-template let-row>
                                        <div [ngClass]="!hideCount && (row.entity.count < count || !row.entity?.count)?'opacity-30 pointer-events-none':''"
                                            class="flex flex-row items-center justify-start w-full gap-2 btn"
                                            (click)="checkRow(row)">
                                            <i [ngClass]="row.checked? 'fa-solid fa-square-check text-exp':'fa-regular fa-square text-zen'"
                                                class=""></i>
                                            <span class="text-zen text-sm font-medium ">{{row.entity.name|
                                                extract:language}}
                                                <span *ngIf="!hideCount">({{row.entity.count || 0}})</span>
                                            </span>

                                        </div>
                                    </ng-template>
                                </zen-tree>
                            </div>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="section.key != 'BusinessLevel' &&  section?.criteria?.length">
                        <h3 [hidden]="!hasCount(section.criteria)" class="text-sm text-zen font-medium text-opacity-50">
                            {{ section.name | translate:language:ModuleNames.Shared }}</h3>
                        <div class="flex flex-col gap-5">
                            <ng-container *ngFor="let criteria of  section?.criteria;let i=index">
                                <div class="flex flex-col gap-1 w-full" [hidden]="criteria?.count == 0">
                                    <div class="flex flex-row justify-between">
                                        <div (click)="setActivatedCriteria(criteria.key)"
                                            class="flex flex-row items-center justify-start gap-1 btn">
                                            <a class="w-4"><i
                                                    [ngClass]="activatedCriteria == criteria.key?'fa-solid text-exp fa-circle-dot':'fa-regular fa-circle'"></i></a>
                                            <h5 class="text-xs text-zen font-medium capitalize">{{(criteria.name
                                                |extract:language)|| (criteria.name|
                                                translate:language:ModuleNames.Shared)}}
                                                <span *ngIf="!hideCount">({{criteria?.count}})</span>
                                            </h5>
                                        </div>
                                        <div class="text-xs text-zen text-opacity-50 cursor-pointer"
                                            (click)="criteria.value = null">
                                            {{ "Reset" | translate:language:ModuleNames.Common }}</div>
                                    </div>
                                    <div [ngClass]="activatedCriteria == criteria.key?'opacity-100 pointer-events-auto':'opacity-60 pointer-events-none'"
                                        class="flex flex-col justify-center bg-opacity-5 rounded">
                                        <z-select [name]="criteria.key" [color]="'exp'"
                                            [placeholder]="'select'|translate:language:ModuleNames.Shared "
                                            [options]="hideCount?criteria.options: criteria.validOptions"
                                            [(ngModel)]="criteria.value" [multiple]="true" [language]="language">
                                            <ng-template #valueTemplate let-value>
                                                <ng-container *ngIf="value">
                                                    {{(value?.name | extract)??value.value}}

                                                    <span *ngIf="!hideCount">({{value?.count}})</span>
                                                </ng-container>
                                            </ng-template>
                                            <ng-template #optionTemplate let-option>
                                                <div (click)="(option?.count < count) && !hideCount ?$event.stopPropagation():null"
                                                    class="customWidth h-full "
                                                    [ngClass]="{'cursor-not-allowed opacity-50':option?.count < count,'-mr-4 -ml-9 pl-9 pr-4': !(language | language),'-mr-9 -ml-4 pl-4 pr-9': (language | language) }">
                                                    {{(option?.name | extract)??option.value}}
                                                    <span *ngIf="!hideCount">({{option?.count}})</span>
                                                </div>
                                            </ng-template>
                                        </z-select>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </div>

        </form>
    </ng-container>
</z-drawer>